export function isModuleLoadError(error) {
  const message = typeof error?.message === "string" ? error.message : "";
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i.test(message);
}
